import { _processQueryStringPart, _splitQueryString } from './index'

export default function getSearchQueryPartAtPosition(
  queryString,
  selectionStart
) {
  const parts = _splitQueryString(queryString)
  let currentPosition = -1
  const partIndex =
    parts &&
    parts.findIndex(part => {
      const startPosition = currentPosition + 1
      const endPosition = startPosition + part.length
      if (selectionStart >= startPosition && selectionStart <= endPosition)
        return true
      currentPosition = endPosition
      return false
    })

  const cutPartsAt = partIndex > -1 ? partIndex : parts.length
  const part = parts && parts[partIndex]
  const partObj = part && _processQueryStringPart(part)
  const operator = partObj && partObj.key
  const value = partObj && partObj.values[0]
  const before = (parts && parts.slice(0, cutPartsAt).join(' ')) || ''
  const after = (parts && parts.slice(cutPartsAt + 1).join(' ')) || ''
  return { operator, value, part, before, after }
}
